export const calculatePensionDetails = (
  payoutYears: number,
  userAge: number,
  estateValue: number
): { monthlyPensionValue: number; isLifeTime: boolean } => {
  const PENSION_CONFIG = {
    CAPITAL_GROWTH_RATE: 0.04, // 4.0% ročne
    INTEREST_RATE: 0.08, // 8.0% p.a.
    TARGET_LTV: 0.9, // 90%
    ONE_TIME_FEE_RATE: 0.04, // 4.0%
    LIFETIME_AGE_THRESHOLD: 95, // Vek, od ktorého sa dôchodok považuje za doživotný
  }
  const endAge = userAge + payoutYears
  const isLifeTime = endAge >= PENSION_CONFIG.LIFETIME_AGE_THRESHOLD
  const actualPayoutYears = isLifeTime
    ? PENSION_CONFIG.LIFETIME_AGE_THRESHOLD - userAge
    : payoutYears
  // This simulation function's logic is now confirmed to be correct by your debug table.
  const simulateLtv = (monthlyPension: number): number => {
    // 1. Calculate the initial fee based on the Credit Limit model.
    const totalNetPayout = monthlyPension * 12 * actualPayoutYears
    if (totalNetPayout <= 0) return 0
    const creditLimit = totalNetPayout / (1 - PENSION_CONFIG.ONE_TIME_FEE_RATE)
    const initialFee = creditLimit * PENSION_CONFIG.ONE_TIME_FEE_RATE
    let currentDebt = initialFee
    let currentPropertyValue = estateValue
    // 2. Use LINEAR property growth.
    const annualPropertyGrowthAmount =
      estateValue * PENSION_CONFIG.CAPITAL_GROWTH_RATE
    const simulationEndAge = PENSION_CONFIG.LIFETIME_AGE_THRESHOLD
    const simulationYears = simulationEndAge - userAge
    for (let year = 1; year <= simulationYears; year++) {
      const shouldPayThisYear = isLifeTime || year <= actualPayoutYears
      const annualPension = shouldPayThisYear ? monthlyPension * 12 : 0
      // 3. Use the AVERAGE DEBT model for interest.
      const interestForYear =
        (currentDebt + annualPension / 2) * PENSION_CONFIG.INTEREST_RATE
      currentDebt += annualPension + interestForYear
      currentPropertyValue += annualPropertyGrowthAmount
    }
    return currentDebt / currentPropertyValue
  }
  // Binary search for the optimal monthly pension.
  let lowerBound = 0
  let upperBound = 10000 // A reasonable upper bound.
  // 100 iterations provides high precision.
  for (let i = 0; i < 100; i++) {
    const midPoint = (lowerBound + upperBound) / 2
    // No need for a tolerance break; let it run to maximize precision before rounding.
    const calculatedLtv = simulateLtv(midPoint)
    if (calculatedLtv < PENSION_CONFIG.TARGET_LTV) {
      // LTV is too low, we can afford a higher pension.
      lowerBound = midPoint
    } else {
      // LTV is too high, pension must be lower.
      upperBound = midPoint
    }
  }

  const monthlyPensionValue = lowerBound

  return {
    monthlyPensionValue: Math.round(monthlyPensionValue),
    isLifeTime,
  }
}
